import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { useAuth } from '../hooks/useAuth'
import { CompetitorUpload } from '../components/CompetitorUpload'
import { Sidebar } from '../components/shared/Sidebar'

export const SettingsPage: React.FC = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [sidebarOpen, setSidebarOpen] = React.useState(false)

  return (
    <div className='flex h-screen bg-background text-foreground font-sans overflow-hidden'>
      <Sidebar
        active='settings'
        onNavigate={section => {
          if (section === 'dashboard') navigate('/dashboard')
          else if (section === 'settings') navigate('/settings')
          else if (section === 'profile') navigate('/profile')
        }}
        mobileOpen={sidebarOpen}
        onMobileClose={() => setSidebarOpen(false)}
      />

      <main className='flex-1 overflow-auto relative min-w-0'>
        <div className='absolute inset-0 bg-gradient-to-tr from-blue-100/50 via-background to-purple-100/50 pointer-events-none' />

        <header className='h-auto min-h-[4.5rem] border-b border-border flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 sm:px-6 lg:px-8 py-4 bg-white/90 backdrop-blur-md sticky top-0 z-10 transition-all shadow-sm'>
          <div className='flex items-center gap-3'>
            <button
              type='button'
              onClick={() => setSidebarOpen(true)}
              className='lg:hidden p-2 rounded-lg hover:bg-slate-100 text-muted-foreground hover:text-foreground'
              aria-label='Open menu'
            >
              <Menu size={24} />
            </button>
            <div>
              <h1 className='text-xl sm:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-foreground to-muted-foreground'>
                Competitors List
              </h1>
              <p className='text-muted-foreground text-xs sm:text-sm truncate max-w-[200px] sm:max-w-none'>
                Welcome back, {user?.name ?? user?.email ?? 'User'}
              </p>
            </div>
          </div>
        </header>

        <div className='p-4 sm:p-6 lg:p-8 max-w-5xl mx-auto space-y-6 sm:space-y-8 relative z-0'>
          <CompetitorUpload />
        </div>
      </main>
    </div>
  )
}

export default SettingsPage
